import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ck_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

// Normalise CMS-uploaded image URLs so they resolve against the current site
// origin (production or preview) instead of a hard-coded environment domain.
export const assetUrl = (u) => {
  if (!u || typeof u !== "string") return u;
  const i = u.indexOf("/api/files/");
  return i >= 0 ? `${BACKEND_URL}${u.slice(i)}` : u;
};

